import { Environments } from '@innovyze/lib_get_service';

const config: any = {
  [Environments.LOCAL]: {
    amInspection: 'https://saas-inspection-management.info360-dev.com/dev',
    //saasAmCost: 'https://saas-am-cost.wlc360a-c-uw2.autodesk.com/dev',
  },
  [Environments.DEV]: {
    amInspection: 'https://saas-inspection-management.info360-dev.com/dev',
    //saasAmCost: 'https://saas-am-cost.wlc360a-c-uw2.autodesk.com/dev',
  },
};

export const apiEnv =
  (localStorage.getItem('apiEnv') as keyof typeof Environments) || undefined;

export default config;
